'use client';

import { ReactNode, useCallback, useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import { DrawerContext } from './drawer-context';
interface Drawers {
  [key: string]: boolean;
}
export const DrawerProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [openDrawers, setOpenDrawers] = useState<Drawers>({});
  const pathname = usePathname();
  const hasFullHeight = pathname !== '/cart';
  const isDrawerOpen = useCallback((id: string) => openDrawers[id] || false, [openDrawers]);
  const openDrawer = useCallback((id: string) => setOpenDrawers(prev => ({
    ...prev,
    [id]: true
  })), []);
  const closeDrawer = useCallback((id: string) => setOpenDrawers(prev => ({
    ...prev,
    [id]: false
  })), []);
  const closeAllDrawers = useCallback(() => {
    setOpenDrawers(prev => {
      const closedDrawers = Object.keys(prev).reduce<Drawers>((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return closedDrawers;
    });
  }, []);
  const providerValue = useMemo(() => ({
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    closeAllDrawers
  }), [closeAllDrawers, closeDrawer, isDrawerOpen, openDrawer]);
  return <DrawerContext.Provider value={providerValue} data-sentry-element="unknown" data-sentry-component="DrawerProvider" data-sentry-source-file="drawer-provider.tsx">
            <div className={cn(hasFullHeight ? 'min-h-[100dvh]' : 'min-h-[calc(100dvh-196px)]')}>{children}</div>
        </DrawerContext.Provider>;
};